import React, { FC } from 'react';
import ProductAddOn from './ProductAddOn';
import { getLocaleInfo } from '@/utils/helpers';
import { ProductAddOnsProps, calculateCartTotal, getCartList } from './utils';
import useLocale from '@/hooks/useLocale';

const ProductAddOns: FC<ProductAddOnsProps> = ({
  productAddOns,
  shopifyProductAddOns,
  selectedAddOns,
  setSelectedAddOns,
  productFields,
  defaultVariant,
}) => {
  const { productAddOnsTitle, productAddOnsTotalLabel } = productFields;
  const locale = useLocale();
  const { browserLocale } = getLocaleInfo(locale);

  const calculatedTotal = calculateCartTotal(
    defaultVariant,
    selectedAddOns,
    browserLocale,
  );
  const cartList = getCartList(productFields.title, selectedAddOns);

  return (
    <div className="mb-3 mt-4">
      {productAddOnsTitle && (
        <p className="mb-4 text-lg font-bold md:text-base">
          {productAddOnsTitle}
        </p>
      )}
      <ul>
        {productAddOns?.map((productAddOn) => {
          const {
            sys: { id },
            fields: { title },
          } = productAddOn;
          return (
            <ProductAddOn
              key={id}
              productAddOn={productAddOn}
              shopifyProductAddOn={shopifyProductAddOns[title]}
              selectedAddOns={selectedAddOns}
              setSelectedAddOns={setSelectedAddOns}
            />
          );
        })}
      </ul>
      {productAddOnsTotalLabel && (
        <p className="font-bold">
          {productFields.productAddOnsTotalLabel} {calculatedTotal}
        </p>
      )}
      <p>{cartList}</p>
    </div>
  );
};

export default React.memo(ProductAddOns);
